import { dispatchAppAction } from './slices/appSlice';
import { useAppDispatch } from './hooks';

// Mirror the exact APP_CONTROLLER_ACTIONS from Recoil
export const APP_CONTROLLER_ACTIONS = {
  UPDATE_MENU: "UPDATE_MENU",
  GET_USER: "GET_USER",
  CATEGORY_TABS: "CATEGORY_TABS",
  FILTER_DELAY: "FILTER_DELAY",
  GET_DOCUMENT: "GET_DOCUMENT",
  UPDATE_PO: "UPDATE_PO",
  GET_PO_LIST: "GET_PO_LIST",
  GET_ALERT_INFO: "GET_ALERT_INFO",
  SHOW_BADGE: "SHOW_BADGE",
  PO_LINE: "PO_LINE",
  EDIT_PO: "EDIT_PO",
  ADD_SUPPLIER: "ADD_SUPPLIER",
  PO_ID: "PO_ID",
  LOGIN: "LOGIN",
  CHANGE_INCOTERM: "CHANGE_INCOTERM",
  REQUEST_UPDATE: "REQUEST_UPDATE",
  DOCUMENT_UPLOAD: "DOCUMENT_UPLOAD",
};

/**
 * Hook that provides the exact same interface as useSetRecoilState(appStateController())
 * This allows existing code to work without any changes:
 * 
 * // Before (Recoil):
 * const dispatchAction = useSetRecoilState(appStateController());
 * dispatchAction({ action: APP_CONTROLLER_ACTIONS.GET_USER, payload: userData });
 * 
 * // After (Redux) - SAME USAGE:
 * const dispatchAction = useAppStateController();
 * dispatchAction({ action: APP_CONTROLLER_ACTIONS.GET_USER, payload: userData });
 */
export const useAppStateController = () => {
  const dispatch = useAppDispatch();
  
  return ({ action, payload }) => {
    dispatch(dispatchAppAction({
      actionType: action,
      payload: payload
    }));
  };
}; 